import axios from 'axios';
import {
  Container, Grid, Backdrop, CircularProgress, Typography, FormLabel, Button, TextField,
  FormControl, Input, InputAdornment,
} from '@material-ui/core';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { getAPIUrl } from '../helpers/CommonHelper';
import moment from 'moment';
import '../styles/Summary.css';

class Summary extends PureComponent {
  paypal = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      transaction: '',
      remarks: '',
      tip: 0,
    };
  }

  componentDidMount() {
    window.paypal.Buttons({
      createOrder: (data, actions, err) => actions.order.create({
        intent: 'AUTHORIZE',
        purchase_units: [
          {
            description: 'Delivery Order',
            amount: {
              currency_code: 'USD',
              value: this.props.quote.totalPrice + this.state.tip,
            },
          },
        ],
      }),
      onApprove: async (data, actions) => {
        const order = await actions.order.authorize();
        if (order && order.status === 'COMPLETED') {
          this.createOrder(order);
        }
      },
      onError: (err) => {
        console.error(err);
        this.setState({
          transaction: 'FAIL',
        });
      },
    }).render(this.paypal.current);
    document.getElementById('tip-input').setAttribute('maxLength', 3);
  }

  remarkHandleChange = (event) => {
    this.setState({
      remarks: event.target.value,
    });
  }

  tipHandleChange = (event) => {
    const val = parseInt(event.target.value === '' ? '0' : event.target.value, 10);
    if (Number.isNaN(val)) {
      return;
    }
    this.setState({
      tip: val,
    });
  }

  createOrder = (transaction) => {
    this.setState({
      isLoading: true,
    });

    axios.post(`${getAPIUrl()}/order/create`, {
      customerEmail: this.props.customer.customerContactDetail.email,
      quoteId: this.props.quote.quoteId,
      ordDropPersonDetails: this.props.customer.dropContactDetail,
      ordPickupPersonDetails: this.props.customer.pickupContactDetail,
      additionalRemarks: this.state.remarks,
      transactionDetails: {
        transactionId: transaction.purchase_units[0].payments.authorizations[0].id,
        transactionDateTime: transaction.update_time,
        transactionType: transaction.intent,
        transactionAmount: transaction.purchase_units[0].amount.value,
        transactionCurrency: transaction.purchase_units[0].amount.currency_code,
      },
    }, {
      timeout: 30000,
    }).then((response) => {
      this.props.addOrder({
        ordTrackingNumber: response.data.ordTrackingNumber,
      });
      this.setState({
        isLoading: false,
        transaction: 'SUCCESS',
      });
    }).catch((error) => {
      console.error(error);
      alert('Something went wrong!!!');
      this.setState({
        isLoading: false,
        transaction: 'FAIL',
      });
    });
  }

  redirectTo = () => {
    if (this.state.transaction === 'SUCCESS') {
      return <Redirect to="/success" />;
    } if (this.state.transaction === 'FAIL') {
      return <Redirect to="/fail" />;
    }
    return null;
  }

  formatPhoneNumber = (str) => {
    const cleaned = ('' + str).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    } 
    return str;
  }

  formatAddress = (str) => {
    if (str != undefined) {
      let addressArr = str.split(', ');
      addressArr.pop();
      return addressArr.join(', ');
    }
    return '';
  }

  render() {
    return (
      <Container>
        {this.redirectTo()}
        <Grid container spacing={3} direction="row" justify="center" alignItems="flex-start">
          <Grid item xs={6} sm={4} md={4}>
            <Typography variant="h6" gutterBottom>
              Pickup details
            </Typography>
            <Typography variant="h6" gutterBottom>
              Address
            </Typography>
            <FormLabel component="legend">
              {this.formatAddress(this.props.quote.originAddress)}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Time
            </Typography>
            <FormLabel component="legend">
              {moment(this.props.quote.pickupDate).format('MM-DD-YYYY, h:mm a')}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Contact Person
            </Typography>
            <FormLabel component="legend">
              {this.props.customer.pickupContactDetail.firstName}
              {' '}
              {this.props.customer.pickupContactDetail.lastName}
            </FormLabel>
            <FormLabel component="legend">
              {this.props.customer.pickupContactDetail.email}
            </FormLabel>
            <FormLabel component="legend">
              {this.formatPhoneNumber(this.props.customer.pickupContactDetail.phone)}
            </FormLabel>
          </Grid>
          <Grid item xs={6} sm={4} md={4}>
            <Typography variant="h6" gutterBottom>
              Drop details
            </Typography>
            <Typography variant="h6" gutterBottom>
              Address
            </Typography>
            <FormLabel component="legend">
              {this.formatAddress(this.props.quote.dropAddress)}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Time
            </Typography>
            <FormLabel component="legend">
              {moment(this.props.quote.dropDate).format('MM-DD-YYYY, h:mm a')}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Contact Person
            </Typography>
            <FormLabel component="legend">
              {this.props.customer.dropContactDetail.firstName}
              {' '}
              {this.props.customer.dropContactDetail.lastName}
            </FormLabel>
            <FormLabel component="legend">
              {this.props.customer.dropContactDetail.email}
            </FormLabel>
            <FormLabel component="legend">
              {this.formatPhoneNumber(this.props.customer.dropContactDetail.phone)}
            </FormLabel>
          </Grid>
          <Grid item xs={false} sm={1} md={1} />
          <Grid item xs={12} sm={3} md={3}>
            <Grid container spacing={3} direction="row" justify="center" alignItems="flex-start">
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Shipping Charges
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.props.quote.totalPrice}
                </FormLabel>
              </Grid>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Tip
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.state.tip}
                </FormLabel>
              </Grid>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Total
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.props.quote.totalPrice + this.state.tip}
                </FormLabel>
              </Grid>
              <br />
              <Grid item xs={8} sm={8} md={8}>
                <Typography gutterBottom>
                  Add a Tip:
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControl fullWidth>
                  <Input
                    id="tip-input"
                    maxLength={3}
                    placeholder="20"
                    value={this.state.tip || ''}
                    onChange={this.tipHandleChange}
                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <TextField
              label="Additional remarks"
              multiline
              rows={4}
              variant="outlined"
              onChange={this.remarkHandleChange}
            />
            <br />
            <br />
            <div>
              <div ref={this.paypal} />
            </div>
          </Grid>
        </Grid>
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container direction="row" justify="center" alignItems="flex-start">
          <div className="margin-top10">
            <Button
              variant="contained"
              onClick={() => this.props.setActiveStep(1)}
            >
              Back
            </Button>
          </div>
        </Grid>
      </Container>
    );
  }
}

export default Summary;
